class ComplementarySliderButtons {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateButtonStates();
  }

  bindEvents() {
    // 监听shopify:section:load事件，确保在主题编辑器重新加载时也能工作
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.complementary-products')) {
        setTimeout(() => {
          this.updateButtonStates();
        }, 100);
      }
    });

    // 监听DOM加载完成
    document.addEventListener('DOMContentLoaded', () => {
      this.updateButtonStates();
    });

    // 监听按钮点击事件（保持基本功能）
    document.addEventListener('click', (event) => {
      if (event.target.closest('.slider-button')) {
        // 按钮点击后不需要更新状态，保持统一的灰色
        console.log('Slider button clicked - maintaining uniform gray style');
      }
    });
  }

  updateButtonStates() {
    const sliderContainers = document.querySelectorAll('.complementary-products .slider-buttons');
    console.log('Found slider containers:', sliderContainers.length);
    
    sliderContainers.forEach((container, index) => {
      const totalSlides = parseInt(container.getAttribute('data-total-slides')) || 1;
      console.log(`Container ${index + 1}: total slides = ${totalSlides}`);
      
      // 移除所有状态类，保持统一的灰色样式
      container.classList.remove('slider-buttons--first', 'slider-buttons--middle', 'slider-buttons--last');
      
      console.log(`Container ${index + 1}: removed state classes, keeping default gray style`);
      console.log(`Container ${index + 1}: current classes:`, container.className);
    });
  }

  findActiveSlide(container, totalSlides) {
    // 不再需要检测slide状态，所有按钮都保持统一的灰色
    console.log('Slide state detection disabled - all buttons are now uniform gray');
    return 1;
  }

  // 手动更新特定容器的状态
  updateContainerState(container, currentSlide, totalSlides) {
    if (!container) return;
    
    container.setAttribute('data-current-slide', currentSlide);
    container.setAttribute('data-total-slides', totalSlides);
    this.updateButtonStates();
  }

  // 测试方法：手动切换按钮状态
  testButtonStates() {
    console.log('=== Testing Button States ===');
    const containers = document.querySelectorAll('.complementary-products .slider-buttons');
    containers.forEach((container, index) => {
      console.log(`Container ${index + 1}:`);
      console.log('  - Classes:', container.className);
      console.log('  - Data attributes:', {
        currentSlide: container.getAttribute('data-current-slide'),
        totalSlides: container.getAttribute('data-total-slides')
      });
      
      const prevButton = container.querySelector('.slider-button--prev');
      const nextButton = container.querySelector('.slider-button--next');
      
      if (prevButton) {
        console.log('  - Prev button background:', getComputedStyle(prevButton).backgroundColor);
      }
      if (nextButton) {
        console.log('  - Next button background:', getComputedStyle(nextButton).backgroundColor);
      }
    });
  }
}

// 初始化
const sliderButtons = new ComplementarySliderButtons();

// 添加全局测试方法
window.testSliderButtons = () => {
  sliderButtons.testButtonStates();
};
